import {
    HttpRequest,
    HttpHandlerFn,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

/** Codigos HTTP que indican que el backend esta en despliegue o caido */
const MAINTENANCE_STATUS_CODES = [502, 503, 504];

/** Endpoints criticos — solo estos disparan redireccion a maintenance */
const CORE_ENDPOINTS = ['/auth/', '/users/me', '/modules/'];

/** Cantidad de errores consecutivos antes de redirigir a maintenance */
const MAINTENANCE_THRESHOLD = 2;

let maintenanceErrorCount = 0;

/**
 * Interceptor HTTP que agrega JWT y detecta errores de autenticacion y despliegue.
 * - 401: Redirige al login (sesion expirada)
 * - 502/503/504 en endpoints criticos: Redirige a maintenance tras errores consecutivos
 */
export function authInterceptor(
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
    const router = inject(Router);
    const token = localStorage.getItem('access_token');
    if (token) {
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
    }
    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            if (MAINTENANCE_STATUS_CODES.includes(error.status)) {
                const isCoreEndpoint = CORE_ENDPOINTS.some((ep) =>
                    request.url.includes(ep)
                );
                if (isCoreEndpoint) {
                    maintenanceErrorCount++;
                    if (maintenanceErrorCount >= MAINTENANCE_THRESHOLD) {
                        maintenanceErrorCount = 0;
                        window.location.href = '/maintenance.html';
                        return EMPTY;
                    }
                }
                return throwError(() => error);
            }
            maintenanceErrorCount = 0;
            if (error.status === 401) {
                localStorage.removeItem('access_token');
                router.navigate(['/']);
            }
            return throwError(() => error);
        })
    );
}
